/**
 * ============================================================================
 * BAMBOOVE — CHUẨN HOẠT ẢNH ACCORDION dùng CHUNG MỌI NƠI (16/10/2026 · phiên 75 m)
 * ----------------------------------------------------------------------------
 * Anh Trung: “tất cả accordion ở trong web, kể cả order note trong giỏ, dùng CÙNG 1 hiệu ứng —
 * cùng tỷ lệ tốc độ mở ra và đóng vào”.
 * CHUẨN: **0.3s · cubic-bezier(0.4, 0, 0.2, 1)** (khai trong assets/bamboove-accordion.css,
 * biến `--bb-acc-ms` / `--bb-acc-ease`) — MỞ và ĐÓNG cùng tốc độ.
 *
 * CÁCH CHẠY: y như chân trang (đã đo là mượt nhất ở MỌI trình duyệt — khác Horizon dùng
 * `block-size:auto` + `interpolate-size` chỉ Chrome 129+ mới nội suy được):
 *   • MỞ  : open=true → height 0 → ép reflow → height = scrollHeight px
 *   • ĐÓNG: height = scrollHeight px → ép reflow → height 0 → xong mới open=false
 *   • Xong: gỡ transition + trả height về auto ⇒ không kẹt chiều cao khi đổi khổ màn hình
 *
 * DÙNG Ở ĐÂU: bất kỳ `<details data-bb-acc>` nào. Hiện có:
 *   · Order note trong giỏ (snippets/cart-drawer.liquid)
 *   · FAQ (sections/bamboove-faq.liquid)
 * Muốn thêm chỗ mới ⇒ chỉ cần gắn `data-bb-acc` vào thẻ <details> (KHÔNG cần sửa JS).
 * ⚠️ Nội dung phải là phần tử NGAY SAU <summary> (JS tự gắn class `.bb-acc-noidung`).
 * ⚠️ Mỗi lúc CHỈ nhận 1 lệnh (bấm lặp không giật — bài học từ chân trang/Nike).
 * ============================================================================
 */
(function () {
  'use strict';

  var CHON = 'details[data-bb-acc]';
  var CHAY = 'bb-acc-chay';
  var MS =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;

  /** Phần nội dung cần chạy hoạt ảnh = phần tử ngay sau <summary> (tự gắn class cho CSS bám). */
  function noiDung(d) {
    var s = d.querySelector('summary');
    if (!s) return null;
    var e = s.nextElementSibling;
    if (e && !e.classList.contains('bb-acc-noidung')) e.classList.add('bb-acc-noidung');
    return e;
  }

  function xong(d, c, laMo) {
    clearTimeout(d._bbAccT);
    d._bbAccT = setTimeout(function () {
      c.classList.remove(CHAY);
      c.style.height = '';
      d.open = laMo;
      d._bbAccDang = 0;
    }, MS + 40);
  }

  function mo(d, c) {
    d._bbAccDang = 1;
    d.open = true;
    c.classList.remove(CHAY);
    c.style.height = '0px';
    void c.offsetHeight; /* ép trình duyệt “chốt” mốc 0 */
    c.classList.add(CHAY);
    c.style.height = c.scrollHeight + 'px';
    xong(d, c, true);
  }

  function dong(d, c) {
    d._bbAccDang = 1;
    c.classList.remove(CHAY);
    c.style.height = c.scrollHeight + 'px';
    void c.offsetHeight; /* ép trình duyệt “chốt” mốc cao hiện tại */
    c.classList.add(CHAY);
    c.style.height = '0px';
    xong(d, c, false);
  }

  function gan() {
    document.querySelectorAll(CHON).forEach(function (d) {
      if (d.dataset.bbAcc === '1') return;
      var s = d.querySelector('summary');
      var c = noiDung(d);
      if (!s || !c) return;
      d.dataset.bbAcc = '1';
      s.addEventListener('click', function (e) {
        e.preventDefault(); /* tự quyết mở/đóng để hoạt ảnh chạy đủ */
        if (d._bbAccDang) return; /* đang chạy hoạt ảnh ⇒ bỏ lệnh mới */
        if (d.open) dong(d, c);
        else mo(d, c);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gan);
  else gan();

  /* Giỏ vẽ lại (thêm/xoá món) ⇒ phần tử order note là MỚI ⇒ phải gắn lại */
  ['shopify:cart:lines-update', 'cart:lines-update', 'cart:update', 'theme-drawer:open'].forEach(
    function (ten) {
      document.addEventListener(ten, function () {
        setTimeout(gan, 60);
      });
    }
  );

  /* Vào trang soạn theme (thêm/xoá khối) ⇒ gắn lại */
  document.addEventListener('shopify:section:load', gan);
})();
